import { render, staticRenderFns } from "./EditFrontDesk.vue?vue&type=template&id=abebf408&scoped=true"
import script from "./EditFrontDesk.vue?vue&type=script&lang=js"
export * from "./EditFrontDesk.vue?vue&type=script&lang=js"
import style0 from "./EditFrontDesk.vue?vue&type=style&index=0&id=abebf408&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abebf408",
  null
  
)

export default component.exports